import { useContext } from 'react'

import slugify from 'scripts/utils/slugify'

import { HeaderContext } from 'reactSite/Header/contexts/HeaderContext'
import { DropdownContext } from 'reactSite/Header/contexts/DropdownContext'

import MenuItem from './MenuItem'

const FirstLevel = () => {
  const headerContext = useContext(HeaderContext)
  const dropdownContext = useContext(DropdownContext)
  const {
    dropdownElements,
    setParentActivated,
    toggleChildren,
    isBlackWeekend
  } = headerContext
  const {
    setItem,
    ActivatedItem
  } = dropdownContext

  const trigger = (itemName) => {
    setParentActivated(itemName)
    ActivatedItem === null
      ? toggleChildren()
      : setItem()
  }

  return (
    <ul className="menu-list-mobile-elements">
      { dropdownElements &&
        dropdownElements.map((item) => (
          <MenuItem
            data={ item }
            trigger={ () => trigger(item.name) }
            key={ slugify(item.name) }
            isBlackWeekend={isBlackWeekend}
          />
        ))
      }
    </ul>
  )
}

export default FirstLevel
